import {POST, DELETE, GET} from "@/services/gateway";

const listRecipients = ({pagination, providerTenantType}) => {
  return POST('account/settings/recipients/list', {pagination, providerTenantType})
}

const deleteRecipient = (id) => {
  return DELETE(`account/settings/recipients`, id)
}

const editRecipient = ({email, name, id, isDailyRecipient, isWeeklyRecipient}) => {
  return POST(`account/settings/recipients/update`, {email, name, id, isDailyRecipient, isWeeklyRecipient})
}

const addRecipient = ({providerTenantType, recipients}) => {
  return POST(`account/settings/recipients`, {providerTenantType, recipients})
}

const updateNotificationSettings = ({providerTenantType, isEnabled}) => {
  return POST(`account/settings/update-notification-settings`, {providerTenantType, isEnabled})
}

const getNotificationSettingsStatus = (providerTenantType) => {
  return GET(`account/settings/notification-settings-status?providerTenantType=${providerTenantType}`)
}

export {
  listRecipients,
  deleteRecipient,
  editRecipient,
  addRecipient,
  updateNotificationSettings,
  getNotificationSettingsStatus,
}
